<template>
    <div class="col-lg-11 col-11 mx-auto">
        <div class="card card-widget widget-user">
            <div class="widget-user-header text-white"
                style="background: url('/assets/images/pexels-belle-co-1000445_people.png')  center;">
                <h2 class="widget-user-desc text-left">Enjoy the Give and Get of Community</h2>
                <h2 class="widget-user-desc text-right">Share the Love.</h2>
                <h4 class="widget-user-username text-right">Help and Be Helped</h4>
            </div>
            <div class="widget-user-image">
                <img class="img-circle" src="/assets/images/pexels-helena-lopes-128x128_friends.png" alt="User Avatar">
            </div>
            <div class="col-md-11">
                <div class="card">
                    <div class="card-body">
                        <a  v-for="channel in channeldata" :key="channel.name"
                            class="btn btn-app m-4 bg-warning" @click="showForum(channel)"
                            v-html="getIconAndName(channel)">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';


export default {
    components: { Errors },
    name: "ForumHome",
    data() {
        return {
            userdata:[],
           channeldata:[],

            errors: {
                        nahme: '',
                        message: '',
                    },

        }
    },
    props: {
        user:'',
        channels:'',

    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.channeldata = JSON.parse(this.channels);
    },

    methods: {

    showForum(channel) {
        console.log("Show forum: " + channel);
        window.location.replace('/forum/channels/' + channel.name);
    },
    getIconAndName(channel) {
        return channel.icon + channel.name;

    }


    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:3px solid #fff;
    background: rgb(209, 219, 248);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}





.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}





</style>
